import { http } from "../../../config/HttpMethod";
import { JETLIFT_ENDPOINTS } from "../../../store/jetlift/endpoints"
import { BWPDOutput, CombinedSpGrPayload, gasCalOutput, gasCalPayload } from "../../../store/model/calculations/fluid";
import { bubblePointPressure, fluidViscosityPayload, gasCompressPayload } from "../../../store/model/jetlift/jetlift";

export const getWaterCutCombinedSpGr = async (payload: CombinedSpGrPayload) => {
    try {
        const response = await http.post(`${JETLIFT_ENDPOINTS?.GET_WATER_CUT_CHANGE_COMBSPGR}`, payload);
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};

export const getBWPDvalue = async (payload: object) => {
    try {
        const response = await http.post<BWPDOutput>(`${JETLIFT_ENDPOINTS?.GET_PROD_RATE_CHANGE}`, payload);
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};

export const getWateCutOilCut = async (payload: number) => {
    const params = {
        WtrCut: payload
    };
    try {
        const response = await http.get<number>(`${JETLIFT_ENDPOINTS?.GET_WATER_CUT_CHANGE}`, { params });
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};

export const getBubblePoint = async (payload: bubblePointPressure) => {
    try {
        const response = await http.get<number>(`${JETLIFT_ENDPOINTS?.GET_BUBBLE_POINT_PRESSURE}`, { params: payload });
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};

export const getOilAPI = async (payload: number) => {
    const params = {
        GasInpAPI: payload,
    };
    try {
        const response = await http.get<number>(`${JETLIFT_ENDPOINTS?.GET_OIL_API_CHANGE}`, { params });
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};

export const getSpGrOil = async (payload: number) => {
    const params = {
        spGraOil: payload,
    };
    try {
        const response = await http.get<number>(`${JETLIFT_ENDPOINTS?.GET_SP_GR_OIL_CHANGE}`, { params });
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};

export const getGasCalData = async (payload: gasCalPayload) => {
    try {
        const response = await http.post<gasCalOutput>(`${JETLIFT_ENDPOINTS?.GET_GAS_CALC_DATA}`, payload);
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};

export const getFluidViscosityChange = async (payload: fluidViscosityPayload) => {
    try {
        const response = await http.post<number>(`${JETLIFT_ENDPOINTS?.GET_FLUID_VISCOSITY_CHANGE}`, payload);
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};

export const getGasCompressValue = async (payload: gasCompressPayload) => {
    try {
        const response = await http.get<number>(`${JETLIFT_ENDPOINTS?.GET_GAS_COMPRESS}`, { params: payload });
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};
